// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__2HFYE","label":"Radio_label__2lmea","checkMark":"Radio_checkMark__2ar-5","disabled":"Radio_disabled__xnYSL"};